import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router';

import { Box, SelectProps, SxProps, Theme } from '@mui/material';
import ClearSelection from 'components/clear-selection';
import RadioSelectItem from 'components/radio-select-item';
import Select from 'components/select';
import _ from 'underscore';
import { useBluViuNutritionState } from '../context/bluviu-nutrition-context';
import { useSelectedSite } from '../hooks/use-selected-site';
import { BluViuNutritionParams } from '../types/bluviu-nutrition-params.type';

type Props = {
  dark?: boolean;
  sx?: SxProps<Theme> | undefined;
} & SelectProps;

const SelectSite: React.FC<Props> = ({ label, dark, fullWidth, sx, ...props }) => {
  const { selectedSiteId } = useSelectedSite();
  const history = useHistory();
  const params = useParams<BluViuNutritionParams>();
  const {
    bluViuNutritionSitesQuery: { isLoading, data: bluViuNutritionSites },
  } = useBluViuNutritionState();

  // #region STATE

  const [siteSearchValue, setSiteSearchValue] = useState<string>('');
  const [siteName, setSiteName] = useState<string>('');

  // #endregion STATE

  const sites = useMemo(() => {
    return _.chain(bluViuNutritionSites)
      .sortBy((s) => s.siteName.toLowerCase())
      .filter((site) => site.siteName.toLowerCase().includes(siteSearchValue.toLowerCase()))
      .value();
  }, [bluViuNutritionSites, siteSearchValue]);

  useEffect(() => {
    if (!!selectedSiteId) {
      let site = sites.find((s) => s.globalSiteId === selectedSiteId.split('/')[0]);
      setSiteName(site?.siteName || '');
    } else setSiteName('');
  }, [selectedSiteId, sites]);

  return (
    <Box display={'flex'} flexDirection={'column'}>
      <Select
        {...props}
        sx={sx}
        isLoading={isLoading}
        tooltipTitle={siteName}
        label={'Select Site'}
        value={selectedSiteId}
        search={{
          value: siteSearchValue,
          onChange: setSiteSearchValue,
        }}
        dark={dark}
        onOpen={() => {
          setSiteSearchValue('');
        }}
        onChange={(event) => {
          history.push(`/bluviu-nutrition/${params.tab}/${event.target.value as string}`);
        }}>
        {sites.map((site) => (
          <RadioSelectItem
            key={site.globalSiteId}
            value={site.globalSiteId}
            onClick={() => setSiteName(site.siteName)}
            selected={site.globalSiteId === selectedSiteId}>
            {site.siteName}
          </RadioSelectItem>
        ))}
      </Select>
      {!!false && (
        <ClearSelection
          sx={{
            justifyContent: 'flex-end',
          }}
          onClick={() => history.push(`/bluviu-nutrition/${params.tab}`)}
        />
      )}
    </Box>
  );
};

export default SelectSite;
